import { Box, Typography, Tooltip } from "@mui/joy";
import { motion } from "framer-motion";

// Цвета сегментов по ключу (совпадают с ключами segments из /stats/overview/)
const COLORS = {
  photos: "#4C6FFF",        // фото книг
  cover_photos: "#00B8A9",  // обложки фото
  generated: "#F5A623",     // сгенерированные (листы, обложки, резон)
  order_pdfs: "#9B5DE5",    // резервные книги (PDF заказов)
};
const FALLBACK = "#94a3b8";

export default function MediaBar({ media }) {
  const segments = media?.segments || [];
  const total = media?.total_bytes || 0;

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mb: 1 }}>
        <Typography level="h3" sx={{ lineHeight: 1 }}>{media?.total_human || "—"}</Typography>
        <Typography level="body-xs" color="neutral">всего медиа</Typography>
      </Box>

      {/* Шкала-полоса: сегменты растягиваются анимацией */}
      <Box
        sx={{
          display: "flex", width: "100%", height: 14, borderRadius: "7px",
          overflow: "hidden", bgcolor: "neutral.softBg",
        }}
      >
        {segments.map((s) => {
          const w = total > 0 ? (s.bytes / total) * 100 : 0;
          if (w <= 0) return null;
          return (
            <Tooltip key={s.key} size="sm" variant="soft" arrow
                     title={`${s.label}: ${s.human} (${s.pct}%)`}>
              <Box
                component={motion.div}
                initial={{ width: "0%" }}
                animate={{ width: `${w}%` }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                sx={{
                  height: "100%", flexShrink: 0,
                  bgcolor: COLORS[s.key] || FALLBACK,
                  borderRight: "1px solid rgba(255,255,255,.55)",
                }}
              />
            </Tooltip>
          );
        })}
      </Box>

      {/* Легенда */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: 1.25 }}>
        {segments.map((s) => (
          <Box key={s.key} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box sx={{
              width: 10, height: 10, borderRadius: "3px", flexShrink: 0,
              bgcolor: COLORS[s.key] || FALLBACK,
            }} />
            <Typography level="body-xs" sx={{ flex: 1 }} noWrap>{s.label}</Typography>
            <Typography level="body-xs" sx={{ fontWeight: 600 }}>{s.human}</Typography>
            <Typography level="body-xs" color="neutral" sx={{ width: 46, textAlign: "right" }}>
              {s.pct}%
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}